import { useState, useEffect } from 'react'

const useMousePosition = () => {
  const [x, setX] = useState()
  const [y, setY] = useState()

  useEffect(() => {
    setX(window.innerWidth / 2)
    setY(window.innerHeight / 2)

    const updatePosition = (e) => {
      setX(e.clientX)
      setY(e.clientY)
    }

    window.addEventListener('mousemove', updatePosition)

    return () => window.removeEventListener('mousemove', updatePosition)
  }, [setX, setY])

  return { x, y }
}

export default useMousePosition
